module.exports = __webpack_public_path__ + "static/logo-2f114831ba4a6cf15ff4c6f16b461885.jpg";